import React, {useState} from 'react';
import {IObjectSelectProps} from '../ObjectSelect';
import {IClassNameProps, withBemMod} from '@bem-react/core';
import {cnObjectSelect} from '../index';
import {useTranslation} from "react-i18next";
import {IApronData} from '../../../../../common-code/interfaces/materials/IApronData';
import {Modal} from '../../Modal';
import {ObjectSelectSelect} from '../Select/ObjectSelect-Select';
import {
    OBJECT_SELECT_TYPE_APRON
} from '../../../../constants';
import {AccessoryList, cnAccessoryList} from '../../../elements/AccessoryList/AccessoryList';

const ObjectSelectApron: React.FC<IObjectSelectProps<IApronData>> =
    ({
         data,
         list,
         title,
         showObject,
         onSelectObject,
        onChangeDepth,
         className,
         facadeMaterials
     }) => {
        const {t} = useTranslation();
        const [showModal, setShowModal] = useState<boolean>(false);

        const emptyObjectData: IApronData = {
            id: 'none',
            title: t('Не выбрано'),
            materialType: 'none',
            height: 0,
            width: 0,
            depth: 0,
            image: ''
        };
        const objectData: IApronData = data && data.object ? data.object : emptyObjectData;

        return (
            <div className={cnObjectSelect({}, [className])}>
                <ObjectSelectSelect
                    className={cnObjectSelect('Select')}
                    image={showObject && objectData.image ? {
                        path: objectData.image,
                        label: objectData.title,
                        width: 60,
                        height: 60
                    } : undefined}
                    color={showObject && !objectData.image && objectData.color ? {
                        path: objectData.color,
                        label: objectData.title,
                        width: 60,
                        height: 60
                    } : undefined}
                    icon={!showObject || (!objectData.image && !objectData.color) ? {
                        path: 'no-photo',
                        label: objectData.title,
                        width: 60,
                        height: 60
                    } : undefined}
                    title={title}
                    description={showObject ? objectData.title : t('Не выбрано') || undefined}
                    callBack={() => {
                        setShowModal(true);
                    }}
                />
                {showModal ?
                    <Modal
                        className={cnObjectSelect('Modal')}
                        visible={showModal}
                        callBack={setShowModal}
                        size={'full'}
                    >
                        {!list || !onSelectObject ?
                            <div className={cnObjectSelect('Error')}>{t('Загрузка данных')}...</div> :
                            <AccessoryList
                                className={cnObjectSelect(cnAccessoryList())}
                                listMaterialData={list}
                                materialData={objectData}
                                showObject={showObject}
                                onSelectObject={onSelectObject}
                                title={title}
                                onChangeDepth={onChangeDepth}
                                facadeMaterials={facadeMaterials}
                                setShowModal={setShowModal}
                            />
                        }
                    </Modal> : null
                }
            </div>
        );
    }

export const withObjectSelectApron = withBemMod<IObjectSelectProps<IApronData>, IClassNameProps>(
    cnObjectSelect(),
    {type: OBJECT_SELECT_TYPE_APRON},
    () => ObjectSelectApron
);